import { render, staticRenderFns } from "./ConfigEmailsList.vue?vue&type=template&id=275f5842&"
import script from "./ConfigEmailsList.js?vue&type=script&lang=js&"
export * from "./ConfigEmailsList.js?vue&type=script&lang=js&"
import style0 from "./ConfigEmailsList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports